import axios, { Method } from '@/apps/open/utils/axios'

/**
 * 申请服务商
 * @param developer
 */
export function applyDeveloper (developer: any) {
  return axios({ url: '/api/developer', method: Method.Post, data: developer })
}

/**
 * 服务商设置
 */
export function getDeveloperSetting (developer_id: any) {
  return axios({ url: '/api/my/developer/setting', method: Method.Get, params: developer_id ? { developer_id } : Object.create(null) })
}

/**
 * 获取服务商补充信息
 */
export function getRemarkInfo (developer_id: any) {
  return axios({ url: '/api/my/developer/remark', method: Method.Get, params: developer_id ? { developer_id } : Object.create(null) })
}

/**
 * 更改服务商邮箱
 */
export function changeEmail (email: string | number, developer_id: number | string) {
  return axios({ url: '/api/developer', method: Method.Put, data: { email, developer_id } })
}

/**
 * 静默注册服务商
 */
export function registerEnterpriseDeveloper (company_id: string) {
  return axios({ url: '/api/me/company_developer', method: Method.Post, data: { company_id } })
}
